import { get, post, deleteMethod } from '@/utils/httpHelper';

module.exports = {
  async findAllCategory () {
    const url = `/esg/security/stakeholder/category/findAllCategory`;
    const body = await get(url);
    return body.data;
  },
  async addNewCategory (category) {
    const url = `/esg/security/stakeholder/category/save`;
    const body = await post(url, category);
    return body.data;
  },
  async deleteCategory (category) {
    const url = `/esg/security/stakeholder/category/remove`;
    const body = await deleteMethod(url, category);
    return body.data;
  }
};



// WEBPACK FOOTER //
// ./src/repositories/stakeholderCategory.repository.js